import apis from "../../core/apis.js";

class RescueReasonsResource {
  constructor($resource) {
    "ngInject";

    this.$resource = $resource;
  }

  getAll(options) {
    return this.$resource(apis.rescueReasons).get(options);
  }
}

export default RescueReasonsResource;



// WEBPACK FOOTER //
// ./src/resources/rescueReasons/rescueReasons.resource.js